import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $,Sortable;

@Component({
  selector: 'app-attr-sort',
  templateUrl: './attr-sort.component.html',
  styleUrls: ['./attr-sort.component.css']
})
export class AttrSortComponent implements OnInit {
  @Input() modelVerId:string;              // 模型版本id
  @Input() selectConcept:any;              // 所属概念
  // 新增或编辑操作成功后向父组件发射数据
  @Output('attrSave') attrSave = new EventEmitter<any>();  
  // 取消操作成功后向父组件发射数据
  @Output('attrCancel') attrCancel = new EventEmitter<any>();  

  ontologyTreeCopyDatas:any = [];
  ontologyTreeDatas:any = [];  // 属性树数据
  readonlySelfIds:any = [];  // 不可选择的父级节点
  sortableDatas:any = [];
  pid = '';

  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getOnlogyTreePageList();
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    const params = {
      "conceptId": this.selectConcept.conceptId,
      "modelVerId": this.modelVerId,
    }
    this.ontologyTreeCopyDatas = [];
    this.ontologyTreeDatas = [];
    this.kmsService.queryeAttrTreeList(params).subscribe(
        result => {
          if (result.code == 200) {
              if (!result.data) {
                this.ontologyTreeCopyDatas = [];
                this.ontologyTreeDatas = [];
                return;
              }
              let datas = result.data;
              if(datas.length>0){
                this.ontologyTreeCopyDatas = JSON.parse(JSON.stringify(datas));
                // 获取概念节点和复合属性
                this.ontologyTreeDatas = this.ontologyTreeCopyDatas.filter(item => item.id == this.selectConcept.conceptId || (item.type === 3 && item.isCompound));
                // 获取一级属性
                this.sortableDatas = this.ontologyTreeCopyDatas.filter(item => item.pid == this.selectConcept.conceptId);
                this.sortInit();
              }
          } else {
              this.message.waring(result.msg);
          }
        }
    )
  }

  // 父级分类下拉点击方法
  handleAttrChange(event) {
    // 获取待排序的数据
    this.sortableDatas = this.ontologyTreeCopyDatas.filter(item => item.pid == event.id);
    this.sortInit();
  }

  // 排序组件初始化
  sortInit(){
    new Sortable($('#sortable')[0], {
        animation: 150,
        ghostClass: 'blue-background-class'
    });
  }

  // 表单提交方法
  onSubmit() {
    // 获取排序信息
    let sortedData = [];
    var elements = [].slice.call(document.querySelectorAll('.list-group-item'));
    elements.forEach((item,index) => {
        sortedData.push(
            {
              id: parseInt(item.id),
              sortNum: index+1,
            }
        )
    })
    this.swMaskService.openMask("数据正在保存,请稍等...");
    this.kmsService.updateAttrSortNumById(sortedData).subscribe(
      result => {
        this.swMaskService.closeMask();
        if (result.code == 200) {
          this.message.success('操作成功！');
          this.attrSave.emit(false);
        } else {
          this.message.waring(result.msg);
        }
      }
    )
  }

  // 取消新增或编辑操作
  cancel(){
    this.attrCancel.emit(true);
  }
}
